(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2441],{

/***/ 49659:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[id]/[slug]",
      function () {
        return __webpack_require__(40274);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9952);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13372);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69826);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89670);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__);







function Badge(param) {
    let { type , variant ="default" , size ="medium"  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    switch(type){
        case "bonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bonus), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("bonus")
                    })
                ]
            });
        case "discount":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discount), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 20
                })
            });
        case "popular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popular), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("popular")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
    }
}


/***/ }),

/***/ 94627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23004);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98456);



function LoadMore(param) {
    let { children , onClick , loading =false , size ="large"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadMore), " ").concat(size === "small" ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().small) : (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().large)),
        disabled: loading,
        onClick: onClick,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 21
        }) : children
    });
}


/***/ }),

/***/ 77262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98456);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23004);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 37562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76098);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 11291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HorizontalLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function HorizontalLine(param) {
    let { height ="1px" , width ="100%" , color ="var(--white)" , margin ="0"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            height,
            width,
            backgroundColor: color,
            margin
        }
    });
}


/***/ }),

/***/ 90026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Price; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(34349);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(64698);
;// CONCATENATED MODULE: ./utils/numberToPrice.ts
const numberToPrice = function(number) {
    let digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (number) {
        return number.toFixed(digits).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
    return "0";
};

;// CONCATENATED MODULE: ./components/price/price.tsx





function Price(param) {
    let { number =0 , minus , symbol , plus , digits , old  } = param;
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    const position = (currency === null || currency === void 0 ? void 0 : currency.position) || "before";
    const currencySymbol = symbol || (currency === null || currency === void 0 ? void 0 : currency.symbol) || "$";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat(minus ? "red" : "", " ").concat(old ? "strike" : ""),
        children: [
            minus ? "-" : "",
            plus ? "+" : "",
            position === "before" ? currencySymbol : "",
            numberToPrice(number, digits),
            position === "after" ? currencySymbol : ""
        ]
    });
}


/***/ }),

/***/ 10214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/productCard/productCard.module.scss
var productCard_module = __webpack_require__(3368);
var productCard_module_default = /*#__PURE__*/__webpack_require__.n(productCard_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(95785);
// EXTERNAL MODULE: ./components/price/price.tsx + 1 modules
var price = __webpack_require__(90026);
// EXTERNAL MODULE: ./components/badge/badge.tsx
var badge = __webpack_require__(12554);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(37562);
// EXTERNAL MODULE: ./node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(18339);
// EXTERNAL MODULE: ./node_modules/remixicon-react/StarFillIcon.js
var StarFillIcon = __webpack_require__(2525);
var StarFillIcon_default = /*#__PURE__*/__webpack_require__.n(StarFillIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/StarLineIcon.js
var StarLineIcon = __webpack_require__(29452);
var StarLineIcon_default = /*#__PURE__*/__webpack_require__.n(StarLineIcon);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(29969);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./containers/productCardCounterContainer/productCardCounterContainer.tsx



const ProductCardCounter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2256).then(__webpack_require__.bind(__webpack_require__, 52256)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52256)
            ]
    }
});
const ProtectedProductCardCounter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4614).then(__webpack_require__.bind(__webpack_require__, 54614)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54614)
            ]
    }
});
function ProductCardCounterContainer(param) {
    let { data  } = param;
    const { isAuthenticated  } = (0,auth_context/* useAuth */.a)();
    if (isAuthenticated) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtectedProductCardCounter, {
            data: data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardCounter, {
        data: data
    });
}

// EXTERNAL MODULE: ./hooks/useLiked.tsx
var useLiked = __webpack_require__(73857);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Heart3FillIcon.js
var Heart3FillIcon = __webpack_require__(72960);
var Heart3FillIcon_default = /*#__PURE__*/__webpack_require__.n(Heart3FillIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Heart3LineIcon.js
var Heart3LineIcon = __webpack_require__(31041);
var Heart3LineIcon_default = /*#__PURE__*/__webpack_require__.n(Heart3LineIcon);
// EXTERNAL MODULE: ./utils/productHref.ts
var productHref = __webpack_require__(32042);
;// CONCATENATED MODULE: ./components/productCard/productCard.tsx
















function ProductCard(param) {
    let { data  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const { isLiked , handleLikeOrDislike  } = (0,useLiked/* default */.Z)({
        type: "product",
        itemId: data === null || data === void 0 ? void 0 : data.id
    });
    const totalPrice = (data === null || data === void 0 ? void 0 : (ref = data.stock) === null || ref === void 0 ? void 0 : ref.total_price) || (data === null || data === void 0 ? void 0 : (ref1 = data.stocks) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.total_price) || 0;
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: (0,productHref/* productHref */.H)(data),
        scroll: true,
        className: (productCard_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (productCard_module_default()).likeButton,
                onClick: (e)=>{
                    e.preventDefault();
                    handleLikeOrDislike();
                },
                children: isLiked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (productCard_module_default()).dislikeIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Heart3FillIcon_default()), {
                        size: 24
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (productCard_module_default()).likeIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Heart3LineIcon_default()), {
                        size: 24
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productCard_module_default()).addToCart,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardCounterContainer, {
                    data: data
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productCard_module_default()).badgeContainer,
                children: [
                    !!((data === null || data === void 0 ? void 0 : (ref3 = data.stock) === null || ref3 === void 0 ? void 0 : ref3.discount) || (data === null || data === void 0 ? void 0 : (ref4 = data.discounts) === null || ref4 === void 0 ? void 0 : ref4.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                            type: "discount",
                            variant: "circle",
                            size: "medium"
                        })
                    }),
                    !!((data === null || data === void 0 ? void 0 : (ref5 = data.stock) === null || ref5 === void 0 ? void 0 : ref5.bonus) || (data === null || data === void 0 ? void 0 : (ref6 = data.stocks) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.bonus)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                            type: "bonus",
                            variant: "circle",
                            size: "medium"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productCard_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data === null || data === void 0 ? void 0 : data.img),
                    alt: data === null || data === void 0 ? void 0 : (ref8 = data.translation) === null || ref8 === void 0 ? void 0 : ref8.title,
                    quality: 90,
                    sizes: "200px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productCard_module_default()).price,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                    number: totalPrice
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (productCard_module_default()).title,
                children: data === null || data === void 0 ? void 0 : (ref9 = data.translation) === null || ref9 === void 0 ? void 0 : ref9.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productCard_module_default()).review,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).rating,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                            value: (ref10 = data === null || data === void 0 ? void 0 : data.r_avg) !== null && ref10 !== void 0 ? ref10 : 0,
                            readOnly: true,
                            color: "var(--yellow-rating)",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((StarFillIcon_default()), {
                                size: 14
                            }),
                            emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((StarLineIcon_default()), {
                                size: 14
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).reviewCount,
                        children: (ref11 = data === null || data === void 0 ? void 0 : data.r_count) !== null && ref11 !== void 0 ? ref11 : 0
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 45729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RangeSlider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-slider/dist/es/prod/components/ReactSlider/ReactSlider.mjs
function s(e){return e&&e.stopPropagation&&e.stopPropagation(),e&&e.preventDefault&&e.preventDefault(),!1}function n(e){return null==e?[]:Array.isArray(e)?e.slice():[e]}function i(e){return null!==e&&1===e.length?e[0]:e.slice()}function o(e){Object.keys(e).forEach((t=>{"undefined"!=typeof document&&document.addEventListener(t,e[t],!1)}))}function r(e,t){return a(function(e,t){let s=e;s<=t.min&&(s=t.min);s>=t.max&&(s=t.max);return s}(e,t),t)}function a(e,t){const s=(e-t.min)%t.step;let n=e-s;return 2*Math.abs(s)>=t.step&&(n+=s>0?t.step:-t.step),parseFloat(n.toFixed(5))}let p=function(p){function u(e){var a;(a=p.call(this,e)||this).onKeyUp=()=>{a.onEnd()},a.onMouseUp=()=>{a.onEnd(a.getMouseEventMap())},a.onTouchEnd=e=>{e.preventDefault(),a.onEnd(a.getTouchEventMap())},a.onBlur=()=>{a.setState({index:-1},a.onEnd(a.getKeyDownEventMap()))},a.onMouseMove=e=>{a.setState({pending:!0});const t=a.getMousePosition(e),s=a.getDiffPosition(t[0]),n=a.getValueFromPosition(s);a.move(n)},a.onTouchMove=e=>{if(e.touches.length>1)return;a.setState({pending:!0});const t=a.getTouchPosition(e);if(void 0===a.isScrolling){const e=t[0]-a.startPosition[0],s=t[1]-a.startPosition[1];a.isScrolling=Math.abs(s)>Math.abs(e)}if(a.isScrolling)return void a.setState({index:-1});const s=a.getDiffPosition(t[0]),n=a.getValueFromPosition(s);a.move(n)},a.onKeyDown=e=>{if(!(e.ctrlKey||e.shiftKey||e.altKey||e.metaKey))switch(a.setState({pending:!0}),e.key){case"ArrowLeft":case"ArrowDown":case"Left":case"Down":e.preventDefault(),a.moveDownByStep();break;case"ArrowRight":case"ArrowUp":case"Right":case"Up":e.preventDefault(),a.moveUpByStep();break;case"Home":e.preventDefault(),a.move(a.props.min);break;case"End":e.preventDefault(),a.move(a.props.max);break;case"PageDown":e.preventDefault(),a.moveDownByStep(a.props.pageFn(a.props.step));break;case"PageUp":e.preventDefault(),a.moveUpByStep(a.props.pageFn(a.props.step))}},a.onSliderMouseDown=e=>{if(!a.props.disabled&&2!==e.button){if(a.setState({pending:!0}),!a.props.snapDragDisabled){const t=a.getMousePosition(e);a.forceValueFromPosition(t[0],(e=>{a.start(e,t[0]),o(a.getMouseEventMap())}))}s(e)}},a.onSliderClick=e=>{if(!a.props.disabled&&a.props.onSliderClick&&!a.hasMoved){const t=a.getMousePosition(e),s=r(a.calcValue(a.calcOffsetFromPosition(t[0])),a.props);a.props.onSliderClick(s)}},a.createOnKeyDown=e=>t=>{a.props.disabled||(a.start(e),o(a.getKeyDownEventMap()),s(t))},a.createOnMouseDown=e=>t=>{if(a.props.disabled||2===t.button)return;a.setState({pending:!0});const n=a.getMousePosition(t);a.start(e,n[0]),o(a.getMouseEventMap()),s(t)},a.createOnTouchStart=e=>t=>{if(a.props.disabled||t.touches.length>1)return;a.setState({pending:!0});const s=a.getTouchPosition(t);a.startPosition=s,a.isScrolling=void 0,a.start(e,s[0]),o(a.getTouchEventMap()),function(e){e.stopPropagation&&e.stopPropagation()}(t)},a.handleResize=()=>{const e=window.setTimeout((()=>{a.pendingResizeTimeouts.shift(),a.resize()}),0);a.pendingResizeTimeouts.push(e)},a.renderThumb=(e,t)=>{const s=a.props.thumbClassName+" "+a.props.thumbClassName+"-"+t+" "+(a.state.index===t?a.props.thumbActiveClassName:""),n={ref:e=>{a["thumb"+t]=e},key:a.props.thumbClassName+"-"+t,className:s,style:e,onMouseDown:a.createOnMouseDown(t),onTouchStart:a.createOnTouchStart(t),onFocus:a.createOnKeyDown(t),tabIndex:0,role:"slider","aria-orientation":a.props.orientation,"aria-valuenow":a.state.value[t],"aria-valuemin":a.props.min,"aria-valuemax":a.props.max,"aria-label":Array.isArray(a.props.ariaLabel)?a.props.ariaLabel[t]:a.props.ariaLabel,"aria-labelledby":Array.isArray(a.props.ariaLabelledby)?a.props.ariaLabelledby[t]:a.props.ariaLabelledby,"aria-disabled":a.props.disabled},o={index:t,value:i(a.state.value),valueNow:a.state.value[t]};return a.props.ariaValuetext&&(n["aria-valuetext"]="string"==typeof a.props.ariaValuetext?a.props.ariaValuetext:a.props.ariaValuetext(o)),a.props.renderThumb(n,o)},a.renderTrack=(e,t,s)=>{const n={key:a.props.trackClassName+"-"+e,className:a.props.trackClassName+" "+a.props.trackClassName+"-"+e,style:a.buildTrackStyle(t,a.state.upperBound-s)},o={index:e,value:i(a.state.value)};return a.props.renderTrack(n,o)};let u=n(e.value);u.length||(u=n(e.defaultValue)),a.pendingResizeTimeouts=[];const h=[];for(let t=0;t<u.length;t+=1)u[t]=r(u[t],e),h.push(t);return a.resizeObserver=null,a.resizeElementRef=react.createRef(),a.state={index:-1,upperBound:0,sliderLength:0,value:u,zIndices:h},a}(0,inheritsLoose/* default */.Z)(u,p);var h=u.prototype;return h.componentDidMount=function(){"undefined"!=typeof window&&(this.resizeObserver=new ResizeObserver(this.handleResize),this.resizeObserver.observe(this.resizeElementRef.current),this.resize())},u.getDerivedStateFromProps=function(e,t){const s=n(e.value);return s.length?t.pending?null:{value:s.map((t=>r(t,e)))}:null},h.componentDidUpdate=function(){0===this.state.upperBound&&this.resize()},h.componentWillUnmount=function(){this.clearPendingResizeTimeouts(),this.resizeObserver&&this.resizeObserver.disconnect()},h.onEnd=function(e){e&&function(e){Object.keys(e).forEach((t=>{"undefined"!=typeof document&&document.removeEventListener(t,e[t],!1)}))}(e),this.hasMoved&&this.fireChangeEvent("onAfterChange"),this.setState({pending:!1}),this.hasMoved=!1},h.getValue=function(){return i(this.state.value)},h.getClosestIndex=function(e){let t=Number.MAX_VALUE,s=-1;const{value:n}=this.state,i=n.length;for(let o=0;o<i;o+=1){const i=this.calcOffset(n[o]),r=Math.abs(e-i);r<t&&(t=r,s=o)}return s},h.getMousePosition=function(e){return[e["page"+this.axisKey()],e["page"+this.orthogonalAxisKey()]]},h.getTouchPosition=function(e){const t=e.touches[0];return[t["page"+this.axisKey()],t["page"+this.orthogonalAxisKey()]]},h.getKeyDownEventMap=function(){return{keydown:this.onKeyDown,keyup:this.onKeyUp,focusout:this.onBlur}},h.getMouseEventMap=function(){return{mousemove:this.onMouseMove,mouseup:this.onMouseUp}},h.getTouchEventMap=function(){return{touchmove:this.onTouchMove,touchend:this.onTouchEnd}},h.getValueFromPosition=function(e){const t=e/(this.state.sliderLength-this.state.thumbSize)*(this.props.max-this.props.min);return r(this.state.startValue+t,this.props)},h.getDiffPosition=function(e){let t=e-this.state.startPosition;return this.props.invert&&(t*=-1),t},h.resize=function(){const{slider:e,thumb0:t}=this;if(!e||!t)return;const s=this.sizeKey(),n=e.getBoundingClientRect(),i=e[s],o=n[this.posMaxKey()],r=n[this.posMinKey()],a=t.getBoundingClientRect()[s.replace("client","").toLowerCase()],p=i-a,u=Math.abs(o-r);this.state.upperBound===p&&this.state.sliderLength===u&&this.state.thumbSize===a||this.setState({upperBound:p,sliderLength:u,thumbSize:a})},h.calcOffset=function(e){const t=this.props.max-this.props.min;if(0===t)return 0;return(e-this.props.min)/t*this.state.upperBound},h.calcValue=function(e){return e/this.state.upperBound*(this.props.max-this.props.min)+this.props.min},h.calcOffsetFromPosition=function(e){const{slider:t}=this,s=t.getBoundingClientRect(),n=s[this.posMaxKey()],i=s[this.posMinKey()];let o=e-(window["page"+this.axisKey()+"Offset"]+(this.props.invert?n:i));return this.props.invert&&(o=this.state.sliderLength-o),o-=this.state.thumbSize/2,o},h.forceValueFromPosition=function(e,t){const s=this.calcOffsetFromPosition(e),n=this.getClosestIndex(s),i=r(this.calcValue(s),this.props),o=this.state.value.slice();o[n]=i;for(let e=0;e<o.length-1;e+=1)if(o[e+1]-o[e]<this.props.minDistance)return;this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0,this.setState({value:o},(()=>{t(n),this.fireChangeEvent("onChange")}))},h.clearPendingResizeTimeouts=function(){do{const e=this.pendingResizeTimeouts.shift();clearTimeout(e)}while(this.pendingResizeTimeouts.length)},h.start=function(e,t){const s=this["thumb"+e];s&&s.focus();const{zIndices:n}=this.state;n.splice(n.indexOf(e),1),n.push(e),this.setState((s=>({startValue:s.value[e],startPosition:void 0!==t?t:s.startPosition,index:e,zIndices:n})))},h.moveUpByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=r(this.props.invert&&"horizontal"===this.props.orientation?t-e:t+e,this.props);this.move(Math.min(s,this.props.max))},h.moveDownByStep=function(e){void 0===e&&(e=this.props.step);const t=this.state.value[this.state.index],s=r(this.props.invert&&"horizontal"===this.props.orientation?t+e:t-e,this.props);this.move(Math.max(s,this.props.min))},h.move=function(e){const t=this.state.value.slice(),{index:s}=this.state,{length:n}=t,i=t[s];if(e===i)return;this.hasMoved||this.fireChangeEvent("onBeforeChange"),this.hasMoved=!0;const{pearling:o,max:r,min:a,minDistance:p}=this.props;if(!o){if(s>0){const n=t[s-1];e<n+p&&(e=n+p)}if(s<n-1){const n=t[s+1];e>n-p&&(e=n-p)}}t[s]=e,o&&n>1&&(e>i?(this.pushSucceeding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const o=n-i*s;t[e-1-i]>o&&(t[e-1-i]=o)}}(n,t,p,r)):e<i&&(this.pushPreceding(t,p,s),function(e,t,s,n){for(let i=0;i<e;i+=1){const e=n+i*s;t[i]<e&&(t[i]=e)}}(n,t,p,a))),this.setState({value:t},this.fireChangeEvent.bind(this,"onChange"))},h.pushSucceeding=function(e,t,s){let n,i;for(n=s,i=e[n]+t;null!==e[n+1]&&i>e[n+1];n+=1,i=e[n]+t)e[n+1]=a(i,this.props)},h.pushPreceding=function(e,t,s){for(let n=s,i=e[n]-t;null!==e[n-1]&&i<e[n-1];n-=1,i=e[n]-t)e[n-1]=a(i,this.props)},h.axisKey=function(){return"vertical"===this.props.orientation?"Y":"X"},h.orthogonalAxisKey=function(){return"vertical"===this.props.orientation?"X":"Y"},h.posMinKey=function(){return"vertical"===this.props.orientation?this.props.invert?"bottom":"top":this.props.invert?"right":"left"},h.posMaxKey=function(){return"vertical"===this.props.orientation?this.props.invert?"top":"bottom":this.props.invert?"left":"right"},h.sizeKey=function(){return"vertical"===this.props.orientation?"clientHeight":"clientWidth"},h.fireChangeEvent=function(e){this.props[e]&&this.props[e](i(this.state.value),this.state.index)},h.buildThumbStyle=function(e,t){const s={position:"absolute",touchAction:"none",willChange:this.state.index>=0?this.posMinKey():void 0,zIndex:this.state.zIndices.indexOf(t)+1};return s[this.posMinKey()]=e+"px",s},h.buildTrackStyle=function(e,t){const s={position:"absolute",willChange:this.state.index>=0?this.posMinKey()+","+this.posMaxKey():void 0};return s[this.posMinKey()]=e,s[this.posMaxKey()]=t,s},h.buildMarkStyle=function(e){var t;return(t={position:"absolute"})[this.posMinKey()]=e,t},h.renderThumbs=function(e){const{length:t}=e,s=[];for(let n=0;n<t;n+=1)s[n]=this.buildThumbStyle(e[n],n);const n=[];for(let e=0;e<t;e+=1)n[e]=this.renderThumb(s[e],e);return n},h.renderTracks=function(e){const t=[],s=e.length-1;t.push(this.renderTrack(0,0,e[0]));for(let n=0;n<s;n+=1)t.push(this.renderTrack(n+1,e[n],e[n+1]));return t.push(this.renderTrack(s+1,e[s],this.state.upperBound)),t},h.renderMarks=function(){let{marks:e}=this.props;const t=this.props.max-this.props.min+1;return"boolean"==typeof e?e=Array.from({length:t}).map(((e,t)=>t)):"number"==typeof e&&(e=Array.from({length:t}).map(((e,t)=>t)).filter((t=>t%e==0))),e.map(parseFloat).sort(((e,t)=>e-t)).map((e=>{const t=this.calcOffset(e),s={key:e,className:this.props.markClassName,style:this.buildMarkStyle(t)};return this.props.renderMark(s)}))},h.render=function(){const e=[],{value:s}=this.state,n=s.length;for(let t=0;t<n;t+=1)e[t]=this.calcOffset(s[t],t);const i=this.props.withTracks?this.renderTracks(e):null,o=this.renderThumbs(e),r=this.props.marks?this.renderMarks():null;return react.createElement("div",{ref:e=>{this.slider=e,this.resizeElementRef.current=e},style:{position:"relative"},className:this.props.className+(this.props.disabled?" disabled":""),onMouseDown:this.onSliderMouseDown,onClick:this.onSliderClick},i,o,r)},u}(react.Component);p.displayName="ReactSlider",p.defaultProps={min:0,max:100,step:1,pageFn:e=>10*e,minDistance:0,defaultValue:0,orientation:"horizontal",className:"slider",thumbClassName:"thumb",thumbActiveClassName:"active",trackClassName:"track",markClassName:"mark",withTracks:!0,pearling:!1,disabled:!1,snapDragDisabled:!1,invert:!1,marks:[],renderThumb:e=>react.createElement("div",e),renderTrack:e=>react.createElement("div",e),renderMark:e=>react.createElement("span",e)};var u=p;

// EXTERNAL MODULE: ./components/rangeSlider/rangeSlider.module.scss
var rangeSlider_module = __webpack_require__(5678);
var rangeSlider_module_default = /*#__PURE__*/__webpack_require__.n(rangeSlider_module);
;// CONCATENATED MODULE: ./components/rangeSlider/rangeSlider.tsx



function RangeSlider(_props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (rangeSlider_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(u, {
            ..._props,
            renderTrack: (props, state)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    ...props,
                    style: {
                        position: "absolute",
                        top: "calc(50% - 4px)",
                        backgroundColor: state.index === 1 ? (_props === null || _props === void 0 ? void 0 : _props.trackColor) || "var(--yellow-rating)" : "var(--grey)",
                        width: state.index === 1 ? "".concat((ref = _props === null || _props === void 0 ? void 0 : _props.value) !== null && ref !== void 0 ? ref : 0, "%") : "100%",
                        height: "8px",
                        borderRadius: "50px"
                    }
                });
            }
        })
    });
}


/***/ }),

/***/ 11471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var remixicon_react_StarFillIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2525);
/* harmony import */ var remixicon_react_StarFillIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StarFillIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StarLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29452);
/* harmony import */ var remixicon_react_StarLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StarLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _rating_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99616);
/* harmony import */ var _rating_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_rating_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function Rating(param) {
    let { value , count =5 , size =20 , onChange , readonly =false , activeColor ="var(--yellow-rating)" , hoverColor ="var(--yellow-rating)" , emptyIcon =/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StarLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}) , fullIcon =/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StarFillIcon__WEBPACK_IMPORTED_MODULE_2___default()), {}) , centered =false  } = param;
    const [hoverValue, setHoverValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    const handleMouseMove = (index)=>{
        if (readonly) {
            return;
        }
        setHoverValue(index);
    };
    const handleMouseLeave = ()=>{
        if (readonly) {
            return;
        }
        setHoverValue(undefined);
    };
    const handleClick = (index)=>{
        if (readonly) {
            return;
        }
        if (onChange) {
            onChange(index + 1);
        }
    };
    const getColor = (index)=>{
        if (hoverValue !== undefined) {
            if (index <= hoverValue) {
                return hoverColor;
            }
        }
        return activeColor;
    };
    const stars = [];
    for(let i = 0; i < count; i++){
        let star;
        if (hoverValue !== undefined) {
            if (i <= hoverValue) {
                star = fullIcon;
            }
        }
        if (i < value) {
            star = fullIcon;
        } else {
            star = emptyIcon;
        }
        if (hoverValue !== undefined) {
            if (i <= hoverValue) {
                star = fullIcon;
            }
        }
        stars.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: "".concat((_rating_module_scss__WEBPACK_IMPORTED_MODULE_4___default().star), " ").concat(readonly ? (_rating_module_scss__WEBPACK_IMPORTED_MODULE_4___default().readOnly) : ""),
            onMouseMove: ()=>handleMouseMove(i),
            onMouseLeave: handleMouseLeave,
            onClick: ()=>handleClick(i),
            children: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(star, {
                size,
                color: getColor(i)
            })
        }, i));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(centered ? (_rating_module_scss__WEBPACK_IMPORTED_MODULE_4___default().centered) : (_rating_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container)),
        children: stars
    });
}


/***/ }),

/***/ 84169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5848);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3075);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21697);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 73857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLiked; }
/* harmony export */ });
/* harmony import */ var _useRedux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var redux_slices_liked__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52565);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29969);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88767);
/* harmony import */ var services_like__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20290);
/* harmony import */ var components_alert_toast__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73714);







function useLiked(param) {
    let { type , itemId  } = param;
    const dispatch = (0,_useRedux__WEBPACK_IMPORTED_MODULE_0__/* .useAppDispatch */ .T)();
    const queryClint = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useQueryClient)();
    const { isAuthenticated  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const { shopList , productList  } = (0,_useRedux__WEBPACK_IMPORTED_MODULE_0__/* .useAppSelector */ .C)((state)=>state.liked);
    const isLiked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        switch(type){
            case "shop":
                return !!shopList.length && shopList.some((item)=>item.shopId === itemId);
            case "product":
                return !!productList.length && productList.some((item)=>item.productId === itemId);
            default:
                return false;
        }
    }, [
        type,
        itemId,
        shopList,
        productList
    ]);
    const { mutate: likeRequest  } = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)({
        mutationFn: (body)=>services_like__WEBPACK_IMPORTED_MODULE_5__/* ["default"].like */ .Z.like(body),
        onError: (err)=>{
            (0,components_alert_toast__WEBPACK_IMPORTED_MODULE_6__/* .error */ .vU)(err === null || err === void 0 ? void 0 : err.message);
        }
    });
    const { mutate: dislikeRequest  } = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)({
        mutationFn: (body)=>services_like__WEBPACK_IMPORTED_MODULE_5__/* ["default"].disLike */ .Z.disLike(body),
        onMutate: async (body)=>{
            if (body.type === "product") {
                await queryClint.cancelQueries([
                    "likedProducts"
                ], {
                    exact: false
                });
                const prevLikeList = queryClint.getQueryData([
                    "likedProducts"
                ], {
                    exact: false
                });
                queryClint.setQueriesData({
                    queryKey: [
                        "likedProducts"
                    ],
                    exact: false
                }, (old)=>{
                    var ref;
                    if (!old) return prevLikeList;
                    return {
                        ...old,
                        pages: old === null || old === void 0 ? void 0 : (ref = old.pages) === null || ref === void 0 ? void 0 : ref.map((page)=>{
                            var ref;
                            return {
                                ...page,
                                data: page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.filter((product)=>{
                                    return (product === null || product === void 0 ? void 0 : product.id) !== body.type_id;
                                })
                            };
                        })
                    };
                });
                return {
                    prevLikeList
                };
            }
        },
        onError: (err)=>{
            (0,components_alert_toast__WEBPACK_IMPORTED_MODULE_6__/* .error */ .vU)(err === null || err === void 0 ? void 0 : err.message);
        }
    });
    const handleLocalLikeOrDislike = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        dispatch((0,redux_slices_liked__WEBPACK_IMPORTED_MODULE_2__/* .likeOrDislike */ .jN)({
            type,
            ["".concat(type, "Id")]: itemId,
            sent: isAuthenticated
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        type,
        itemId,
        isAuthenticated
    ]);
    const handleLikeOrDislike = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (isAuthenticated) {
            if (isLiked) {
                dislikeRequest({
                    type,
                    type_id: itemId
                });
            } else {
                likeRequest({
                    type,
                    type_id: itemId
                });
            }
        }
        handleLocalLikeOrDislike();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        type,
        itemId,
        isAuthenticated,
        isLiked
    ]);
    return {
        isLiked,
        handleLikeOrDislike
    };
}


/***/ }),

/***/ 37490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useModal() {
    let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen);
    const handleOpen = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(true);
    };
    const handleClose = ()=>setOpen(false);
    return [
        open,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 40274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ProductPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./containers/productContainer/productContainer.module.scss
var productContainer_module = __webpack_require__(60998);
var productContainer_module_default = /*#__PURE__*/__webpack_require__.n(productContainer_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./containers/productContainer/productContainer.tsx




const ProductInfoLoading = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2339).then(__webpack_require__.bind(__webpack_require__, 82339)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82339)
            ]
    }
});
const ProductGalleryLoading = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7524).then(__webpack_require__.bind(__webpack_require__, 7524)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7524)
            ]
    }
});
const ProductInfo = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4678), __webpack_require__.e(8594)]).then(__webpack_require__.bind(__webpack_require__, 98594)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98594)
            ]
    }
});
const ProductGallery = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2431).then(__webpack_require__.bind(__webpack_require__, 62431)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(62431)
            ]
    }
});
function ProductContainer(param) {
    let { data , loading =false  } = param;
    var ref;
    const defaultStock = data === null || data === void 0 ? void 0 : (ref = data.stocks) === null || ref === void 0 ? void 0 : ref[0];
    const [selectedStock, setSelectedStock] = (0,react.useState)(defaultStock);
    (0,react.useEffect)(()=>{
        if (defaultStock) {
            setSelectedStock(defaultStock);
        }
    }, [
        defaultStock
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (productContainer_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (productContainer_module_default()).mainInfo,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (productContainer_module_default()).gallery,
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGalleryLoading, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGallery, {
                        data: data,
                        selectedStock: selectedStock
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (productContainer_module_default()).info,
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoLoading, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo, {
                        data: data,
                        selectedStock: selectedStock,
                        setSelectedStock: setSelectedStock
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./services/product.ts
var product = __webpack_require__(32837);
// EXTERNAL MODULE: ./components/productCard/productCard.tsx + 1 modules
var productCard = __webpack_require__(10214);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(9526);
// EXTERNAL MODULE: ./components/productList/productList.module.scss
var productList_module = __webpack_require__(86089);
var productList_module_default = /*#__PURE__*/__webpack_require__.n(productList_module);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84601);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(20835);
;// CONCATENATED MODULE: ./components/productList/productList.tsx











function ProductList(param) {
    let { title , params ={} , enabled =true  } = param;
    var ref;
    const { t , i18n  } = (0,es/* useTranslation */.$G)();
    const { data , isFetching  } = (0,react_query_es.useQuery)({
        queryKey: [
            "products",
            i18n.language,
            params
        ],
        queryFn: ()=>{
            const paramsData = {
                lang: i18n.language,
                perPage: 10,
                page: 1,
                ...params
            };
            return product/* default.getAll */.Z.getAll(paramsData);
        },
        enabled
    });
    // ⬇️ MINIMA MODIFICA
    const filtered = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.filter((p)=>p.id !== params.product_id);
    if (!isFetching && !(filtered === null || filtered === void 0 ? void 0 : filtered.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {});
    }
    const renderView = ()=>{
        if (isFetching) {
            return Array.from(new Array(4)).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        className: (productList_module_default()).shimmer
                    }, index)
                }, index));
        }
        return filtered === null || filtered === void 0 ? void 0 : filtered.map((product)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productCard/* default */.Z, {
                    data: product
                })
            }, product === null || product === void 0 ? void 0 : product.id);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (productList_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productList_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (productList_module_default()).title,
                    children: t(title)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                navigation: true,
                modules: [
                    swiper_esm/* Navigation */.W_
                ],
                spaceBetween: 20,
                breakpoints: {
                    1500: {
                        slidesPerView: 6
                    },
                    1200: {
                        slidesPerView: 5
                    },
                    1000: {
                        slidesPerView: 4
                    },
                    700: {
                        slidesPerView: 3
                    },
                    450: {
                        slidesPerView: 2
                    },
                    0: {
                        slidesPerView: 1
                    }
                },
                children: renderView()
            })
        ]
    });
}

// EXTERNAL MODULE: ./services/review.ts
var review = __webpack_require__(88946);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(37490);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(29969);
// EXTERNAL MODULE: ./components/button/primaryButton.tsx
var primaryButton = __webpack_require__(77262);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Message2FillIcon.js
var Message2FillIcon = __webpack_require__(42781);
var Message2FillIcon_default = /*#__PURE__*/__webpack_require__.n(Message2FillIcon);
// EXTERNAL MODULE: ./components/button/load-more.tsx
var load_more = __webpack_require__(94627);
// EXTERNAL MODULE: ./components/productReview/productReview.module.scss
var productReview_module = __webpack_require__(44040);
var productReview_module_default = /*#__PURE__*/__webpack_require__.n(productReview_module);
// EXTERNAL MODULE: ./components/productReview/productComments.module.scss
var productComments_module = __webpack_require__(78263);
var productComments_module_default = /*#__PURE__*/__webpack_require__.n(productComments_module);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightSLineIcon.js
var ArrowRightSLineIcon = __webpack_require__(97169);
var ArrowRightSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightSLineIcon);
// EXTERNAL MODULE: ./components/line/horizontalLine.tsx
var horizontalLine = __webpack_require__(11291);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/productReview/productReviewCard.module.scss
var productReviewCard_module = __webpack_require__(56859);
var productReviewCard_module_default = /*#__PURE__*/__webpack_require__.n(productReviewCard_module);
// EXTERNAL MODULE: ./node_modules/remixicon-react/StarFillIcon.js
var StarFillIcon = __webpack_require__(2525);
var StarFillIcon_default = /*#__PURE__*/__webpack_require__.n(StarFillIcon);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/productReview/productReviewCard.tsx






function ProductReviewCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (productReviewCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productReviewCard_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                        className: (productReviewCard_module_default()).userFullName,
                        children: [
                            (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.firstname) || "",
                            " ",
                            (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.lastname) || ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (productReviewCard_module_default()).ratingContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((StarFillIcon_default()), {
                                size: 18
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (productReviewCard_module_default()).rating,
                                children: (data === null || data === void 0 ? void 0 : data.rating) || 0
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productReviewCard_module_default()).datePublished,
                children: [
                    t("posted.on"),
                    " ",
                    dayjs_min_default()(data === null || data === void 0 ? void 0 : data.created_at).format("MMM, DD YYYY")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (productReviewCard_module_default()).comment,
                children: (data === null || data === void 0 ? void 0 : data.comment) || t("no.comment")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/productReview/productComments.tsx








function ProductComments(param) {
    let { data , handleOpenReviews  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (productComments_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productComments_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (productComments_module_default()).title,
                        children: t("reviews")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: (productComments_module_default()).seeAllButton,
                        onClick: handleOpenReviews,
                        children: [
                            t("see.all"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightSLineIcon_default()), {
                                size: 24
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontalLine/* default */.Z, {
                color: "var(--grey)",
                margin: "20px 0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productComments_module_default()).listContainer,
                children: (data === null || data === void 0 ? void 0 : data.length) ? data === null || data === void 0 ? void 0 : data.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontalLine/* default */.Z, {
                                color: "var(--grey)",
                                margin: "20px 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviewCard, {
                                data: item
                            })
                        ]
                    }, item === null || item === void 0 ? void 0 : item.id);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (productComments_module_default()).emptyContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/delivery.webp",
                            alt: t("empty"),
                            width: 200,
                            height: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("no.comments")
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/productReview/productSummary.module.scss
var productSummary_module = __webpack_require__(17160);
var productSummary_module_default = /*#__PURE__*/__webpack_require__.n(productSummary_module);
// EXTERNAL MODULE: ./components/rating/rating.tsx
var rating = __webpack_require__(11471);
// EXTERNAL MODULE: ./components/rangeSlider/rangeSlider.tsx + 1 modules
var rangeSlider = __webpack_require__(45729);
;// CONCATENATED MODULE: ./components/productReview/productSummary.tsx






function ProductSummary(param) {
    let { data  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    var ref;
    const groupValues = Object.values((ref = data === null || data === void 0 ? void 0 : data.group) !== null && ref !== void 0 ? ref : {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
    });
    const getPercent = (value)=>{
        var ref;
        if (!value) {
            return 0;
        }
        var ref1;
        const total = (ref1 = data === null || data === void 0 ? void 0 : data.count) !== null && ref1 !== void 0 ? ref1 : 0;
        return Number((ref = value / total * 100) === null || ref === void 0 ? void 0 : ref.toFixed(0)) || 0;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (productSummary_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productSummary_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (productSummary_module_default()).title,
                        children: t("customer.reviews")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (productSummary_module_default()).description,
                        children: [
                            t("average.rating"),
                            ": ",
                            (data === null || data === void 0 ? void 0 : data.avg) || 0,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "(",
                                    (data === null || data === void 0 ? void 0 : data.count) || 0,
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productSummary_module_default()).main,
                children: groupValues === null || groupValues === void 0 ? void 0 : groupValues.map((value, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (productSummary_module_default()).row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (productSummary_module_default()).reviewStar,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(rating/* default */.Z, {
                                value: value,
                                readonly: true,
                                count: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (productSummary_module_default()).body,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rangeSlider/* default */.Z, {
                                        value: getPercent(value)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (productSummary_module_default()).percent,
                                        children: [
                                            getPercent(value),
                                            " %"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/shopCard/shopMiniCard.module.scss
var shopMiniCard_module = __webpack_require__(86356);
var shopMiniCard_module_default = /*#__PURE__*/__webpack_require__.n(shopMiniCard_module);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(37562);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/shopHref.ts
var shopHref = __webpack_require__(76896);
;// CONCATENATED MODULE: ./components/shopCard/shopMiniCard.tsx





function ShopMiniCard(param) {
    let { data , label  } = param;
    var ref, ref1;
    if (!data) return null; // ✅ evita errore se data è undefined
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: (0,shopHref/* shopHref */.E)(data),
        className: (shopMiniCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopMiniCard_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    sizes: "60px",
                    src: data === null || data === void 0 ? void 0 : data.logo_img,
                    alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shopMiniCard_module_default()).info,
                children: [
                    !!(label === null || label === void 0 ? void 0 : label.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (shopMiniCard_module_default()).label,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (shopMiniCard_module_default()).value,
                        children: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/productReview/productReview.tsx














const DrawerContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4678), __webpack_require__.e(7533), __webpack_require__.e(1274)]).then(__webpack_require__.bind(__webpack_require__, 47107)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47107)
            ]
    }
});
const Reviews = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2175), __webpack_require__.e(1852), __webpack_require__.e(4516), __webpack_require__.e(3562)]).then(__webpack_require__.bind(__webpack_require__, 74516)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(74516)
            ]
    }
});
function ProductReview(param) {
    let { productId , productUuid , shop  } = param;
    var ref, ref1, ref2, ref3;
    const { t  } = (0,es/* useTranslation */.$G)();
    const [open, handleOpen, handleClose] = (0,useModal/* default */.Z)();
    const { isAuthenticated  } = (0,auth_context/* useAuth */.a)();
    const { data: reviews , hasNextPage , isFetchingNextPage  } = (0,react_query_es.useInfiniteQuery)({
        queryKey: [
            "reviews",
            "products",
            productUuid
        ],
        queryFn: (param)=>{
            let { pageParam =1  } = param;
            return review/* default.getAll */.Z.getAll(productUuid, "products", {
                column: "user",
                page: pageParam,
                perPage: 3
            });
        },
        getNextPageParam: (lastPage)=>{
            var ref, ref1;
            if ((lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.meta) === null || ref === void 0 ? void 0 : ref.current_page) < (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.meta) === null || ref1 === void 0 ? void 0 : ref1.last_page)) {
                var ref2;
                return (lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.meta) === null || ref2 === void 0 ? void 0 : ref2.current_page) + 1;
            }
            return undefined;
        },
        staleTime: 0,
        enabled: !!productUuid
    });
    const reviewList = ((ref1 = reviews === null || reviews === void 0 ? void 0 : (ref = reviews.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>{
        return item === null || item === void 0 ? void 0 : item.data;
    })) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean)) || [];
    const { data: summary  } = (0,react_query_es.useQuery)({
        queryKey: [
            "summary",
            "products",
            productId
        ],
        queryFn: ()=>review/* default.getSummary */.Z.getSummary(productId, "products"),
        staleTime: 0,
        enabled: !!productId
    });
    const { isLoading: isCheckCanReviewLoading , isError , data  } = (0,react_query_es.useQuery)({
        queryKey: [
            "canReview",
            "products",
            productId
        ],
        queryFn: ()=>review/* default.canReview */.Z.canReview({
                type: "product",
                type_id: productId
            }),
        staleTime: 0,
        enabled: !!productId && isAuthenticated
    });
    const isAbleToAddReview = !(!isAuthenticated || isError || isCheckCanReviewLoading || !(data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.ordered) || !!(data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : ref3.added_review));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (productReview_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (productReview_module_default()).comments,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductComments, {
                                data: reviewList,
                                handleOpenReviews: handleOpen
                            }),
                            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(load_more/* default */.Z, {
                                loading: isFetchingNextPage,
                                children: t("load.more")
                            }),
                            isAbleToAddReview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((Message2FillIcon_default()), {
                                        size: 24
                                    }),
                                    fullWidth: false,
                                    size: "small",
                                    onClick: handleOpen,
                                    children: t("add.comment")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (productReview_module_default()).summary,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSummary, {
                                data: summary
                            }),
                            !!shop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopMiniCard, {
                                data: shop,
                                label: t("product.store")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerContainer, {
                open: open,
                onClose: handleClose,
                anchor: "right",
                PaperProps: {
                    style: {
                        padding: 0
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                    type: "products",
                    typeId: productId || 0,
                    typeUuid: productUuid
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(84169);
;// CONCATENATED MODULE: ./pages/product/[id]/[slug].tsx
// pages/product/[id]/[slug].tsx





var __N_SSP = true;
function ProductPage(param) {
    let { product  } = param;
    var ref, ref1;
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: product === null || product === void 0 ? void 0 : (ref = product.translation) === null || ref === void 0 ? void 0 : ref.title,
                description: product === null || product === void 0 ? void 0 : (ref1 = product.translation) === null || ref1 === void 0 ? void 0 : ref1.description,
                image: product === null || product === void 0 ? void 0 : product.img
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        maxWidth: "1052px",
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContainer, {
                            data: product,
                            loading: false
                        }, product === null || product === void 0 ? void 0 : product.id),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList, {
                            title: "related.products",
                            params: {
                                category_id: product === null || product === void 0 ? void 0 : product.category_id,
                                brand_id: product === null || product === void 0 ? void 0 : product.brand_id,
                                product_id: product === null || product === void 0 ? void 0 : product.id
                            },
                            enabled: !!(product === null || product === void 0 ? void 0 : product.id)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReview, {
                            productId: product === null || product === void 0 ? void 0 : product.id,
                            productUuid: product === null || product === void 0 ? void 0 : product.uuid,
                            shop: product === null || product === void 0 ? void 0 : product.shop
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 32837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);
// services/product.ts

const productService = {
    // liste
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/paginate", {
            params
        }),
    getAllShopProducts: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/products"), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/search", {
            params
        }),
    getViewed: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/product-histories/paginate", {
            params
        }),
    // singolo prodotto
    // UUID (legacy): /rest/products/:uuid
    getById: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        }),
    // **NUMERICO**: /rest/products/id/:id  --> quello che useremo nella pagina
    getByIdNumber: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/id/".concat(id), {
            params
        }),
    // bulk per ids (rimane com’è)
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/ids", {
            params
        }),
    // alias temporaneo (deprecato)
    getByIdLegacyUuid: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (productService);


/***/ }),

/***/ 88946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const reviewService = {
    getAll: function(id) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "products", params = arguments.length > 2 ? arguments[2] : void 0;
        if (type === "products") {
            return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/".concat(type, "/reviews/").concat(id), {
                params
            });
        }
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/".concat(type, "/").concat(id, "/reviews"), {
            params
        });
    },
    getSummary: function(id) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "products", params = arguments.length > 2 ? arguments[2] : void 0;
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/".concat(type, "/").concat(id, "/reviews-group-rating"), {
            params
        });
    },
    canReview: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/added-review", {
            params
        }),
    create: function(id) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "products", body = arguments.length > 2 ? arguments[2] : void 0;
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/rest/".concat(type, "/review/").concat(id), body);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (reviewService);


/***/ }),

/***/ 95785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 32042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ productHref; }
/* harmony export */ });
/* harmony import */ var _slug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83047);
// utils/productHref.ts

function productHref(p) {
    var ref;
    if (!p) return "#";
    const title = (p === null || p === void 0 ? void 0 : (ref = p.translation) === null || ref === void 0 ? void 0 : ref.title) || (p === null || p === void 0 ? void 0 : p.title) || "";
    return "/product/".concat(p.id, "/").concat((0,_slug__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .l)(title));
}


/***/ }),

/***/ 76896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ shopHref; }
/* harmony export */ });
/* harmony import */ var utils_slug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83047);
// utils/shopHref.ts

function shopHref(s) {
    var ref;
    const title = (s === null || s === void 0 ? void 0 : (ref = s.translation) === null || ref === void 0 ? void 0 : ref.title) || (s === null || s === void 0 ? void 0 : s.name) || "";
    return "/shop/".concat(s.id, "/").concat((0,utils_slug__WEBPACK_IMPORTED_MODULE_0__/* .compactSlug */ .Z)(title));
}


/***/ }),

/***/ 83047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ compactSlug; },
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
// utils/slug.ts
/**
 * slugify: usato per i PRODOTTI
 * Risultato:
 * - minuscolo
 * - solo lettere e numeri
 * - trattini come separatori
 * Esempio: "Uova Omega 3 Fresche" → "uova-omega-3-fresche"
 */ function slugify(input) {
    return (input || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "") // rimuove accenti
    .toLowerCase().trim().replace(/[^a-z0-9]+/g, "-") // tutto ciò che non è a-z0-9 diventa "-"
    .replace(/^-+|-+$/g, ""); // rimuove trattini ai bordi
}
/**
 * compactSlug: usato per gli SHOP
 * Risultato:
 * - minuscolo
 * - solo lettere e numeri
 * - nessun separatore
 * Esempio: "Avicola del Sole" → "avicoladelsole"
 */ function compactSlug(input) {
    return (input || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "") // rimuove accenti
    .toLowerCase().replace(/[^a-z0-9]/g, ""); // elimina tutto ciò che non è a-z0-9
}


/***/ }),

/***/ 9952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BHeKC","default":"badge_default__18BvY","circle":"badge_circle__mQVZ_","text":"badge_text__cdsyf","large":"badge_large__bhCOW","medium":"badge_medium__3BTPx","bonus":"badge_bonus__Ice67","discount":"badge_discount__gVAeQ","popular":"badge_popular__ywwJB"};

/***/ }),

/***/ 76098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 3368:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"productCard_wrapper__ztIcZ","likeButton":"productCard_likeButton__r2ZAt","dislikeIcon":"productCard_dislikeIcon__2geyM","likeIcon":"productCard_likeIcon__aY3LH","addToCart":"productCard_addToCart__TD_N_","badgeContainer":"productCard_badgeContainer__0GSMs","badge":"productCard_badge__N7EGr","imageContainer":"productCard_imageContainer__6uEuG","price":"productCard_price__t9Hq0","title":"productCard_title__0ht20","review":"productCard_review__yoZ_X","rating":"productCard_rating__gdU_4","reviewCount":"productCard_reviewCount__gunhv"};

/***/ }),

/***/ 86089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productList_container__Su_a5","header":"productList_header__kwZJI","title":"productList_title__jts3p","shimmer":"productList_shimmer___CJEP","list":"productList_list__y2yiC"};

/***/ }),

/***/ 78263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productComments_container__ao0HL","header":"productComments_header__GqHV1","title":"productComments_title__Xv2xt","seeAllButton":"productComments_seeAllButton__kzFtf","listContainer":"productComments_listContainer__hItgH","emptyContainer":"productComments_emptyContainer__uyJqo"};

/***/ }),

/***/ 44040:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productReview_container__Yeae0","comments":"productReview_comments__ifEVe","summary":"productReview_summary__G55Yn"};

/***/ }),

/***/ 56859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productReviewCard_container__87bkE","header":"productReviewCard_header__bnwfG","userFullName":"productReviewCard_userFullName__BD84J","ratingContainer":"productReviewCard_ratingContainer___gtBc","rating":"productReviewCard_rating__ibSaU","datePublished":"productReviewCard_datePublished__s7Poo","comment":"productReviewCard_comment__9IF79"};

/***/ }),

/***/ 17160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productSummary_container__UNb7G","header":"productSummary_header__k_ZrZ","title":"productSummary_title__q57MM","description":"productSummary_description__Rb1J6","main":"productSummary_main__7Z_6Q","row":"productSummary_row__0XJbR","reviewStar":"productSummary_reviewStar__Gx6YT","body":"productSummary_body__oCfIN","percent":"productSummary_percent__ILy8X"};

/***/ }),

/***/ 5678:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"rangeSlider_container__UPgP4"};

/***/ }),

/***/ 99616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"rating_container__PwTzZ","star":"rating_star__nCVnc","centered":"rating_centered__Isbd0","readOnly":"rating_readOnly__mAbkC"};

/***/ }),

/***/ 86356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shopMiniCard_container__7g7lq","image":"shopMiniCard_image__kXhq7","info":"shopMiniCard_info__6E8Vh","label":"shopMiniCard_label__pDu8u","value":"shopMiniCard_value__yXuxb"};

/***/ }),

/***/ 60998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productContainer_container__VufON","mainInfo":"productContainer_mainInfo__ilECH","gallery":"productContainer_gallery__MFLoG","info":"productContainer_info__2f35P"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 97169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 72960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Heart3FillIcon = function Heart3FillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2z' })
  );
};

var Heart3FillIcon$1 = React__default['default'].memo ? React__default['default'].memo(Heart3FillIcon) : Heart3FillIcon;

module.exports = Heart3FillIcon$1;


/***/ }),

/***/ 31041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Heart3LineIcon = function Heart3LineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2zm-3.566 15.604c.881-.556 1.676-1.109 2.42-1.701C18.335 14.533 20 11.943 20 9c0-2.36-1.537-4-3.5-4-1.076 0-2.24.57-3.086 1.414L12 7.828l-1.414-1.414C9.74 5.57 8.576 5 7.5 5 5.56 5 4 6.656 4 9c0 2.944 1.666 5.533 4.645 7.903.745.592 1.54 1.145 2.421 1.7.299.189.595.37.934.572.339-.202.635-.383.934-.571z' })
  );
};

var Heart3LineIcon$1 = React__default['default'].memo ? React__default['default'].memo(Heart3LineIcon) : Heart3LineIcon;

module.exports = Heart3LineIcon$1;


/***/ }),

/***/ 42781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Message2FillIcon = function Message2FillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455zM7 10v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z' })
  );
};

var Message2FillIcon$1 = React__default['default'].memo ? React__default['default'].memo(Message2FillIcon) : Message2FillIcon;

module.exports = Message2FillIcon$1;


/***/ }),

/***/ 2525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var StarFillIcon = function StarFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928z' })
  );
};

var StarFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(StarFillIcon) : StarFillIcon;

module.exports = StarFillIcon$1;


/***/ }),

/***/ 29452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var StarLineIcon = function StarLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26zm0-2.292l4.247 2.377-.949-4.773 3.573-3.305-4.833-.573L12 5.275l-2.038 4.42-4.833.572 3.573 3.305-.949 4.773L12 15.968z' })
  );
};

var StarLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(StarLineIcon) : StarLineIcon;

module.exports = StarLineIcon$1;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9526,719,9360,9774,2888,179], function() { return __webpack_exec__(49659); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);